export default __webpack_public_path__ + "static/media/detail.ecaff7d4.png";